import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)
import Api from '../lib/server.js';
import store from '../store/store.js'
import router from '../router/router.js';
import ElementUI from 'element-ui'
Vue.use(ElementUI)
/*----------- ↓ 顶部消息提示(ElementUI Message) -----------*/
const showMES = (content, type = 'info', duration = 3500) =>{
  return ElementUI.Message({
		showClose: true,
		message: content,
		type: type,
		customClass: 'custom-el-message',
		duration: duration
	});
};
/*------- ↓ 关闭所有顶部消息提示(ElementUI Message) -------*/
const msgCloseAll = () => {
  ElementUI.Message.closeAll();
};
/*------------------ ↓ 简化版 axios 请求 ------------------*/
const axiosGet = opt => {
  axios({
    method: "GET",
    url: opt.url,
  }).then(res=>{
    if(res.data.code == 0){
      opt.success(res);
    }
    else if(res.data.code != 0 && opt.fail){
      opt.fail(res);
    }
    else if(res.data.code != 0 && res.data.msg){
      getDataFail(res.data.msg, res);
    }
    else{
      getDataFail(tip, res);
    };
  }).catch(err => {
    getDataFail(tip, err);
  });
};
/**
 * ↓ 简化版 axios 请求
 * opt.url: 请求接口
 * opt.data: 附带参数
 */

const axiosPost = opt => {
  // axios.defaults.headers.common['Access-Token'] = store.state.user['Access-Token']
  let errTip = opt.failTip ? opt.failTip : '操作失败';
  // console.log(opt)
  axios({
    method: "POST",
    url: opt.url,
    data: opt.data,
    headers: {
      'Access-Token': store.state.user['Access-Token'],
      cid: store.state.user.cid
      // 'Content-Type':'application/json',
    },
	})
	.then(res => {
		const oData = (res && res.data) ? res.data : null;
    errTip = (oData && oData.msg) ? oData.msg : errTip;

    if (oData && oData.code == 0) {
      opt.success(res);
    }
    else if (oData && oData.code == 1001) {
      showMES('登录超时，请重新登录！','error');
      router.replace({name:'LogInPage'});
    }
    else if (oData && oData.code && opt.fail) {
      getDataFail(oData.msg, res);
      opt.fail(res);
    }
    else {
			console.error('res err');
      getDataFail(errTip, res);
    }
	})
	.catch(err => {
		console.error('catch err:', err);
		ElementUI.Message.closeAll();
		showMES(errTip, 'error', 5000);
		opt.fail && opt.fail(err);
  })
	.finally(() => {
		console.log('%c%s','color: #51CEE8;','finally:');
		opt.complete && opt.complete();
		// store.commit('setFullSizeLoading', false);
	});
};
/*------------------ ↓ 获取数据成功的回调 ------------------*/
const getResSuccess = (res, opt, tip) => {
  if(res.data.code == 0){
    opt.success(res);
  }
  else if(res.data.code != 0 && res.data.msg && opt.fail){
    getDataFail(res.data.msg, res);
    opt.fail(res);
  }
  else if(res.data.code != 0 && res.data.msg){
    getDataFail(res.data.msg, res);
  }
  else{
    getDataFail(tip, res);
  };
};
/*------------------ ↓ 获取数据失败的回调 ------------------*/
const getDataFail = (tip, err) => {
  ElementUI.Message.closeAll();
  ElementUI.Message({
    showClose: true,
    message: tip + '！',
    type: 'error',
    duration: 5000,
    customClass: 'custom-el-message'
  });
  console.error(tip + '，返回的数据 or 失败原因 ↓\n', err);
};
/*------------------ ↓ 发起Websocket请求 ------------------*/
const httpWebsocket = opt => {
  const isSupportWS = Boolean('WebSocket' in window); // 浏览器是否支持WebSocket
  console.log('是否支持WebSocket请求:',isSupportWS);
  if(!isSupportWS){
    showMES('您的浏览器不支持 WebSocket!','warning');
    return false;
  };
  // let ws = new WebSocket("ws://192.168.1.74:9968");   // 本地
  let ws = new WebSocket("ws://129.211.131.24:9968"); // 在线
  return ws
};
/**
 * ↓ 获取relativeJson (客户、设备、角色、意图、领域 等)
 */
const httpGetRelativeJson = () => {
  axiosPost({
    url: Api.relativeJsonGet,
    failTip: '获取 客户(单位)、设备、角色、意图、领域 等数据失败',
    success: res => getRelativeJsonSuccess(res.data.data)
  });
};
/**
 * ↓ 获取relativeJson (客户、设备、角色、意图、领域 等) 成功
 */
const getRelativeJsonSuccess = data => {
  const titleArr = [
    { id:2, title:'管理员' },
    { id:3, title:'设备平台管理员' },
    { id:4, title:'业务问答管理员' },
    { id:5, title:'智能留言管理员' },
    { id:6, title:'寻路导航管理员' }
	];
  data.roJson = data.roJson.map(obj => {
    const target = titleArr.find(v => v.id == obj.id);
    obj.title = target ? target.title : null;
    return obj;
  });
  store.commit('setRelativeJson', data);
};
/**
 * ↓ 把 搜索内容对象(this.searchInfo) 中的键值对
 *   添加到 (请求表格数据所需的参数) param 中
 */
const addSearchParam = (searchInfo, param) => {
  const keysArr = Object.keys(searchInfo);
  const valsArr = Object.values(searchInfo);
  // console.log(
  //   'keysArr:\n',keysArr,
  //   '\nvalsArr:\n',valsArr
  // );
  keysArr.forEach((v,i)=>{
    if(valsArr[i] || valsArr[i] == 0){ param[v] = valsArr[i] };
  });
  return param
};
const tableHeight = () => {
  let table = document.querySelector('.grid-wrap');
  let tableBox = table ? table.parentElement : null;
  console.log(tableBox)
  return tableBox ? tableBox.offsetHeight : 0
};
/**
 * ↓ 返回 文件类型 'image' 或 'video'
 */
const returnMediaType = path => {
  // return path ? judgeMediaType(path) : null;
  // console.log(path.substring(0,5))
  return path ? path.substring(0,5) : null;
};
/**
 * ↓ 返回 文件类型 'image' 或 'video'
 */
const judgeMediaType = path => {
  const videoType = ["mp4", "avi"];
  const imageType = ["jpeg", "jpg", "png"];

  const typeArr = path.split(".");
  const typeStr = typeArr.length > 1 ? typeArr[1] : "";

  // console.log("typeStr:", typeStr);
  const isImage = imageType.some(v => v == typeStr);
  const isVideo = videoType.some(v => v == typeStr);
  // console.log("isImage:", isImage, "\nisVideo:", isVideo);
  const type = isImage ? 'image' : 'video';
  return isImage || isVideo ? type : null
};
/**
 * ↓ 返回 文件类型 'image' 或 'video'
 */
const getSystemName = arr => {
  const record = arr.find(record => record.meta.system);
  const name = record ? record.meta.system : null;
  // console.log('name:',name);
  return name;
};
/*---------------- ↓ 返回手机号码格式是否正确 ---------------*/
const isPhone = phoneNum => {
  // const regMobile = /^[1][0-9]{10}$/
  const regMobile = /^[1][3456789]\d{9}$/;
  // const regMobile = /^[1][1-9]{10}$/
  return regMobile.test(phoneNum);
};
/**
 * ↓ 返回固定电话格式是否正确
 */
const isTelNum = telNum => {
	const regFixedTel1 = /^(0\d{2,3}-\d{5,8})$/;
	const regFixedTel2 = /^(0\d{2,3}\d{5,8})$/;
	// const regFixedTel1 = /^(0\d{2,3}-\d{7,8})$/;
	// const regFixedTel2 = /^(0\d{2,3}\d{7,8})$/;
	return regFixedTel1.test(telNum) || regFixedTel2.test(telNum);
};
/*------------------ ↓ 返回邮箱格式是否正确 -----------------*/
const isEmail = value => {
  const regEmail = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/
  return regEmail.test(value)
};
/**
 * ↓ 返回是否全为字母和数字
 */
const isLettersAndNums = value => {
	const reg = /^[a-z0-9]+$/i;
	return reg.test(value);
};
/**
 * ↓ 初始化 输入列表中 value 值
 */
const clearInpListVals = arr => {
	const textTypes = ['text', 'textarea', 'integer', 'contactWay', 'phoneNum', 'tel'];
	arr.forEach(obj => {
		Vue.set(obj, 'error', false);
		const isTextType = textTypes.some(v => v === obj.valType);
		if (isTextType) {
			// Vue.set(obj,'value','');
			obj.value = '';
		}
		else if (obj.valType == 'select') {
			// Vue.set(obj,'value','');
			// obj.value = ''; // obj.options[0][obj.optionValue];
			obj.value = obj.options[0][obj.optionValue];
		}
		else if (obj.valType == 'switch') {
			// Vue.set(obj,'value',obj.inactVal);
			// obj.value = obj.inactVal
			obj.value = obj.actVal
		};
	});
};
/**
 * ↓ 输出规定格式的时间字符串
 * @param {*} value 传入的值，可能是 date格式的日期、时间戳、规定格式的时间字符串
 * @param {*} typeRequired 返回的 时间字符串 类型 fullDate:包含小时分钟 其他情况只包含年月日
 */
const formatDate = (value, typeRequired) => {
	const type = judgeType(value);	// 判断传入数据的类型
	switch(type){
		case 'date':
			return dateToFormStr(value, typeRequired);
		case 'number':
			return timeStampToFormStr(value, typeRequired);
		case 'string':
			return (typeRequired == 'fullDate') ? value.substring(0, 16) : value.substring(0, 10);
		default:
			return '无';
	};
};
/**
 * ↓ date格式数据 转换成规定格式的时间字符串
 * @param {*} date date格式的值
 * @param {*} type 返回的 时间字符串 类型 fullDate:包含小时分钟 其他情况只包含年月日
 */
const dateToFormStr = (date, type) => {
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2,0);
	const day = String(date.getDate()).padStart(2,0);
	const hour = String(date.getHours()).padStart(2,0);
	const minute = String(date.getMinutes()).padStart(2,0);
	const dateStr = year +'-'+ month +'-'+ day;
	const timeStr = hour +':'+ minute;
	const result = (type == 'fullDate') ? (dateStr +' '+ timeStr) : dateStr;
	return result;
};
/**
 * ↓ 时间戳 转换成规定格式的时间字符串
 * @param {*} time 时间戳值
 * @param {*} type 返回的 时间字符串 类型 fullDate:包含小时分钟 其他情况只包含年月日
 */
const timeStampToFormStr = (time, type) => {
	let date = new Date(time * 1000);
	let y = date.getFullYear();
	let MM = date.getMonth() + 1;
	MM = ('0' + MM).slice(-2);
	let d = date.getDate();
	d = ('0' + d).slice(-2);
	let h = date.getHours()
	h = ('0' + h).slice(-2)
	let m = date.getMinutes()
	m = ('0' + m).slice(-2)
	
	const dateStr = y +'-'+ MM +'-'+ d;
	const timeStr = h +':'+ m;

	const result = (type == 'fullDate') ? (dateStr +' '+ timeStr) : dateStr;
	return result;
	// let dateStr01 = new Date(time).toLocaleString();
	// let dateStr02 = dateStr01.replace(/\//g,'-');
	// return dateStr02.slice(0, dateStr01.length - 3);
};
// /*---------- ↓ 输出格式化后的标准日期 ----------*/
// const formatDate = time => {
//   // const type = typeof time;
//   const type = judgeType(time);
//   console.log('type:\n',type);
//   if(!time && time !== 0){
//     return '无'
//   }
//   else if(type == 'number'){
//     return timeStampTransform(time)
//   }
//   else if(type == 'string'){
//     return time.substring(0, 10)
//   };
// };
/*---------------------- ↓ 时间戳转换成标准时间 ----------------------*/
const timeStampTransform = time => {
  let date = new Date(time * 1000);
  let y = date.getFullYear();
  let MM = date.getMonth() + 1;
  MM = ('0' + MM).slice(-2);
  let d = date.getDate();
  d = ('0' + d).slice(-2);
  // let h = date.getHours()
  // h = ('0' + h).slice(-2)
  // let m = date.getMinutes()
  // m = ('0' + m).slice(-2)
  return y + '-' + MM + '-' + d // + ' ' + h + ':' + m
  // let dateStr01 = new Date(time).toLocaleString();
  // let dateStr02 = dateStr01.replace(/\//g,'-');
  // return dateStr02.slice(0, dateStr01.length - 3);
};
/**
 * ↓ 读取 cookie 中存储的值 
 */
const getCookie = cookieName => {
  cookieName += '=';
  const cookieList = document.cookie.split(';');
  // console.log('cookieList:',cookieList);
  const cookieItem = cookieList.find(v=>v.trim().indexOf(cookieName) != -1);
  if(cookieItem){
    const item = cookieItem.trim();
    return item.substring(cookieName.length, cookieItem.length);
  };
};
/**
 * ↓ 判断数据类型
 */
const judgeType = value => {
  let type = Object.prototype.toString;
  const typeString = type.call(value);
  let str = typeString.substring(8, typeString.length - 1);
  return str.toLowerCase();
};
/* ↓ 返回两数组相同项组成的数组 */
const getTwoArrSame = (arr1, arr2) => {
  const arrSame = [];
  arr1.forEach(v1 => {
    const s = arr2.find(v2 => v2 == v1);
    if (s) arrSame.push(s);
  })
  return arrSame;
};

// 文件转 图片 关键函数  异步
const getVideoImage = (file, call) => {
  // ↓ 调用
  // this.globalFn.getVideoImage(file, data => {
  //   // console.log('data ↓\n',data);
  //   this.fileTable.push({
  //     mediaType: "video",
  //     name: file.name,
  //     src: data.src,
  //     file: file,
  //     duration: data.duration,
  //     sort: 1
  //   });
  // });
  let video = document.createElement('video');
  video.src = URL.createObjectURL(file);
  video.autoplay = true;
  video.pause();
  video.onloadeddata = e => {
    const width = video.videoWidth;
    const height = video.videoHeight;
    let canvas = document.createElement('canvas');
    let ctx = canvas.getContext('2d');
    canvas.width = width;
    canvas.height = height;
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    const src = canvas.toDataURL('image/jpeg', 1);
    let image = {
      src: src,
      width: width,
      height: height,
      currentTime: video.currentTime,
      duration: video.duration
    };
    typeof call == 'function' ? call.call(file, image) : console.log(image);
  };
};
//上传图片的  传入files
function getObjectURL(file) {
  var url = null;
  if(window.createObjectURL != undefined) { // basic
    url = window.createObjectURL(file);
  } else if(window.URL != undefined) { // mozilla(firefox)
    url = window.URL.createObjectURL(file);
  } else if(window.webkitURL != undefined) { // webkit or chrome
    url = window.webkitURL.createObjectURL(file);
  }
  return url;
};
const copyToClipboard = content => {
	let transfer = document.createElement('input');
	document.body.appendChild(transfer);
	transfer.value = content;  // 这里表示想要复制的内容
	transfer.focus();
	transfer.select();
	if(document.execCommand('copy')){
		document.execCommand('copy');
	};
	transfer.blur();
	showMES('复制成功', 'success');
	document.body.removeChild(transfer);
};
/**
 * ↓ 深拷贝 
 */
const deepClone = target => {
	if(typeof target === 'object'){
		let cloneTarget = Array.isArray(target) ? [] : {};
		for(const key in target){
			cloneTarget[key] = deepClone(target[key]);
		};
		return cloneTarget;
	}else{
		return target;
	};
};
/**
 * 将传入对象转换成FormData格式并返回（递归）：
 * @param {*} obj 传入的值，数据类型为对象或数组（必填）
 * @param {*} form 用于返回的目标FormData（非必填）
 * @param {*} faKey 父对象属性名（非必填）
 */
const objectToFormData = (obj, form, faKey) => {
	var fd = form || new FormData();
	var formKey;
	// console.log(judgeType(obj))
	if (judgeType(obj) == 'array') {
		// ↓ 数组继续往下遍历
		obj.forEach((v, i) => {
			const isObj = (typeof obj[key] === 'object' && !(obj[key] instanceof File));
			if (isObj) objectToFormData(v, fd, `${faKey}[${i}]`);
			else fd.append(`${faKey}[${i}]`, v);
		});
	}
	else if (judgeType(obj) == 'filelist') {
		for (const f of obj) fd.append(faKey, f);
	}
	else {
		// ↓ 数组也是对象，键值对
		for (var key in obj) {
			// console.group(obj)
			// console.log(obj)
			// console.log(key)
			// console.log(obj.hasOwnProperty(key))
			// console.groupEnd()
			if (obj.hasOwnProperty(key)) {
				formKey = faKey ? `${faKey}[${key}]` : key;
				const isObj = (typeof obj[key] === 'object' && !(obj[key] instanceof File));
				if (isObj) objectToFormData(obj[key], fd, formKey);
				else fd.append(formKey, obj[key]);
			};
		}
	}
	return fd;
};
/*----------------- ↓ 删除 cookie (退出登录)----------------*/
const clearCookie = () => {
  document.cookie = 'username=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
  document.cookie = 'password=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
  document.cookie = 'isAutoLogIn=0;expires=Thu, 01 Jan 1970 00:00:00 GMT';
};
export default {
  showMES,
  msgCloseAll,
  axiosGet,
  axiosPost,
  getDataFail,
  httpWebsocket,
  httpGetRelativeJson,
  addSearchParam,
  tableHeight,
  returnMediaType,
  getSystemName,
  isPhone,
	isTelNum,
	isEmail,
	isLettersAndNums,
	clearInpListVals,
  judgeType,
  timeStampTransform,
  formatDate,
  getCookie,
  clearCookie,
  getTwoArrSame,
	getVideoImage,
	deepClone,
	objectToFormData,
	copyToClipboard
}



// WEBPACK FOOTER //
// ./src/lib/globalFn.js